import { EyeIcon } from '@heroicons/react/24/outline';

const ViewerCount = ({ viewerCount }: { viewerCount: number }) => {
  return (
    <div className="viewer-counter-container">
      <EyeIcon className="viewer-counter-icon" />
      <div className="viewer-count-number">{viewerCount}</div>
    </div>
  );
};

export default ViewerCount;
